import Component from "../core/Component"
import withScroll from "../core/withScroll"
import withMedia from "../core/withMedia"

class Image extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            scaleRatio: .3,
            clipRatio: .05,
            translateYRatio: null
        })

        this.ref = {
            image: null,
        }

        this.ref.image = this.element.querySelector("img")
        this.ratio = 0
    }

    prepare() {

    }

    render(ratio) {
        this.ratio = ratio
        requestAnimationFrame(this.handleRafRender)
    }

    handleRafRender = () => {
        const ratio = this.ratio

        //scale
        if (this.options.scaleRatio) {
            const delta = this.options.scaleRatio
            this.scale = 1 + delta - customEase(ratio) * delta
            this.ref.image.style.transform = `scale(${this.scale})`
        }

        //clip
        if (this.options.clipRatio) {
            this.clip = this.options.clipRatio * 100 - ratio * this.options.clipRatio * 100
            this.element.style.clipPath = `inset(${this.clip}% 0 0 0)`
        }

        //translateY
        if (this.options.translateYRatio) {
            this.translateY = -ratio * this.options.translateYRatio
            this.ref.image.style.transform = `translateY(${this.translateY}px)`
        }
    }

    scroll(ratio) {
        this.render(ratio)
    }

    scrollResize(){
        //
    }
}

export default withMedia(withScroll(Image))

function customEase(p) {
    return Math.pow(p, .25)
}